export default function ResultAlert(props) {

    if (!props.visible) {
        return null;
    }

    return (<span className="text-success">
        Results available <i className="bi bi-exclamation-circle"></i>
        <a className="btn btn-link text-reset ms-2 p-0 mb-1 fw-bold" onClick={() => window.scroll(0, 0)}>Go to Results</a>
    </span>);
}